import React from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import Chart from "chart.js";
import ReactTooltip from "react-tooltip";
import ChartCosts from "./costs_chart";
import { calcTransportCosts } from "./calc_costs.js";
import icon_pt from '../../../images/pt-symbol.png'
import icon_car from '../../../images/car-symbol.png'
import icon_bike from '../../../images/bike-symbol.png'
import icon_walk from '../../../images/walk-symbol.png'


var Backbone = require("backbone");

/**ONLY FOR DEV**/

//import Dev from '../../../models/dev';

/**DEV END**/

export default class DailyTripsPage extends React.Component {
  constructor(props) {
    super(props);

    /**ONLY FOR DEV**/

    //		var x = 0;

    //		var dev = new Dev();

    //		dev.setUpDataForResults(1);

    /**DEV END**/

    var carsUsedIni = this.getCarsUsed();

    var pubtransUsedIni = this.getTripIdsWithPubTransCosts();

    this.lpobj = window.datastore.lps.get(this.props.match.params.placeid);

    this.dts = this.lpobj.get("dailyTrips");

    this.state = {
      nextTripId: (this.dts.length + 1).toString(),

      carsUsed: carsUsedIni,

      pubtransUsed: pubtransUsedIni,

      title_name: this.lpobj.get("name"),

      costs: this.recalcCosts(),

      showLoading: false
    };

    this.changeCarsUsed = this.changeCarsUsed.bind(this);

    this.getCarsUsed = this.getCarsUsed.bind(this);

    this.getTripIdsWithPubTransCosts = this.getTripIdsWithPubTransCosts.bind(
      this
    );

    this.changePubTransUsed = this.changePubTransUsed.bind(this);

    this.recalcCosts = this.recalcCosts.bind(this);

    this.refreshCosts = this.refreshCosts.bind(this);

    this.loadingOnOff = this.loadingOnOff.bind(this);

    function copyDailyTargetsFromOne(comp) {
      if (
        comp.props.match.params.placeid === "2" &&
        !comp.lpobj.get("alreadyCopiedDailyTargets")
      ) {
        var dts_1 = window.datastore.lps.get("1").get("dailyTrips");

        for (var i = 0; i < dts_1.length; i++) {
          var dt_1 = dts_1.models[i];

          comp.dts.add({
            xy: dt_1.get("xy"),

            id: dt_1.get("id"),

            name: dt_1.get("name"),

            enhancedByWebService: false,

            freq: dt_1.get("freq"),

            purposetext: dt_1.get("purposetext")
          });
        }

        comp.lpobj.set("alreadyCopiedDailyTargets", true);
      }
    }

    //

    copyDailyTargetsFromOne(this);
  }

  getCarsUsed() {
    var carsUsed = [];

    var dts = window.datastore.lps
      .get(this.props.match.params.placeid)
      .get("dailyTrips");

    for (var i = 0; i < dts.models.length; i++) {
      var dt = dts.models[i];

      if (dt.get("selectedMode") === "car") {
        var carId = dt.get("id_car");

        if (carsUsed.indexOf(carId) === -1) {
          carsUsed.push(carId);
        }
      }
    }

    return carsUsed;
  }

  changeCarsUsed() {
    this.setState({
      carsUsed: this.getCarsUsed()
    });
  }

  getTripIdsWithPubTransCosts() {
    var tripIdsWithPt = [];

    var dts = window.datastore.lps
      .get(this.props.match.params.placeid)
      .get("dailyTrips");

    for (var i = 0; i < dts.models.length; i++) {
      var dt = dts.models[i];

      if (
        dt.get("selectedMode") === "public" &&
        dt.get("enhancedByWebService") == true
      ) {
        tripIdsWithPt.push(dt.get("id"));
      }
    }

    return tripIdsWithPt;
  }

  changePubTransUsed() {
    this.setState({
      pubtransUsed: this.getTripIdsWithPubTransCosts()
    });
  }

  recalcCosts() {
    return calcTransportCosts(this.props.match.params.placeid);
  }

  refreshCosts() {
    var costs = this.recalcCosts();

    this.setState({
      costs: costs
    });
  }

  loadingOnOff(on) {
    if (on) {
      this.setState({
        showLoading: true
      });
    } else {
      this.setState({
        showLoading: false
      });
    }
  }

  //

  //	componentWillReceiveProps(nextProps) {

  //		const location = {

  //				  pathname: '/wohnstandorte/1/taeglichewege',

  //				  state: { fromDashboard: true }

  //				}

  //		hashHistory.replace(location)

  //		}

  render() {
    return (
      <div>
        <nav className="navbar navbar-default">
          <div className="container-fluid header">
            {/*<div className="row">

					    <div className="col-lg-1 header-text">

					    <h5>Wohnstandort</h5>

					    </div>

					    <div className="col-lg-1 header-text">

					    <h5>Wohnumfeld</h5>

					    </div>

					    <div className="col-lg-1 header-text">

					    <h5>Wohnkosten</h5>

					    </div>

					    <div className="col-lg-1 header-text">

					    <h5 className="bold">Mobilität</h5>

					    </div>

				  </div>*/}

            <div>
              <ol className="breadcrumb">
                {this.props.match.params.placeid === "2" ? (
                  <li className="">
                    <Link to={"wohnstandorte/1/addressmap"}>
                      Zu Wohnstandort 1
                    </Link>
                  </li>
                ) : (
                  ""
                )}

                {this.props.match.params.placeid === "1" ? (
                  <li className="">
                    <a href="/">Start</a>
                  </li>
                ) : (
                  ""
                )}

                <li className="">
                  <Link
                    to={
                      "/wohnstandorte/" +
                      this.props.match.params.placeid +
                      "/addressmap"
                    }
                  >
                    {this.props.match.params.placeid === "2"
                      ? "Vergleichsstandort"
                      : "Wohnstandort"}
                  </Link>
                </li>

                <li className="">
                  <Link
                    to={
                      "/wohnstandorte/" +
                      this.props.match.params.placeid +
                      "/infrastruktur"
                    }
                  >
                    Infrastruktur
                  </Link>
                </li>

                <li className="">
                  <Link
                    to={
                      "/wohnstandorte/" +
                      this.props.match.params.placeid +
                      "/wohnkosten"
                    }
                  >
                    Wohnkosten
                  </Link>
                </li>

                <li className="active">Mobilität</li>

                {this.props.match.params.placeid === "2" ? (
                  <li className="not-active">Vergleich</li>
                ) : (
                  <li className="not-active">Ergebnis</li>
                )}

                {this.props.match.params.placeid === "1" ? (
                  <li className="not-active">Vergleichsstandort</li>
                ) : (
                  ""
                )}
              </ol>
            </div>
          </div>
        </nav>

        <div className="container-fluid normal-page">
          {this.state.showLoading ? (
            <div className="loading">Loading&#8230;</div>
          ) : (
            ""
          )}

          <h4>{this.state.title_name}</h4>

          {this.props.match.params.placeid === "2" ? (
            <h4>(Vergleichsstandort)</h4>
          ) : (
            ""
          )}

          <h3>Regelmäßige Wege aller Personen im Haushalt</h3>

          <span className="help-block">
            Geben sie hier{" "}
            <span className="bold">
              regelmäßige Wege von Personen im Haushalt
            </span>{" "}
            an. z.B: 5 mal in der Woche zum Arbeitsplatz oder 4 mal zur Schule.
            Damit können sie die Gesamtkosten für ihre Mobilitätsanforderungen
            abschätzen.
          </span>

          <hr />

          <div className="center-block chart-container">
            <h4>Verhältnis von monatlichen Wohn- und Mobilitätskosten</h4>

            <ChartCosts costs={this.state.costs} />
          </div>

          <DailyTripsList
            placeid={this.props.match.params.placeid}
            changeCarsUsed={this.changeCarsUsed}
            changePubTransUsed={this.changePubTransUsed}
            refreshCosts={this.refreshCosts}
            loadingStatus={this.loadingOnOff}
          />

          <ReactTooltip multiline={true} />

          <div className="form-inline">
            <AddDailyTripButton id={this.props.match.params.placeid} />{" "}
            <span
              className="tooltip-icon"
              data-tip="Durch die Angabe einer Zieladresse werden Fahrzeiten für diesen Weg angezeigt, nur Hinweg ohne Retourweg.<br> Sie können für jeden Weg das Verkehrsmittel wählen (Bus/Bahn, Auto, Fahrrad, Fußweg).<br> Danach werden die Weg-Kosten für das Monats-Diagramm automatisch berechnet. Jeder Weg wird dabei hin und retour gezählt."
            >
              [?]
            </span>
          </div>

          <hr />

          <Settings
            placeid={this.props.match.params.placeid}
            carsUsed={this.state.carsUsed}
            tripIdsWithPt={this.state.pubtransUsed}
            refreshCosts={this.refreshCosts}
          />

          {this.props.match.params.placeid === "1" ? (
            <div className="continue-button ">
              <Link
                to={
                  "/wohnstandorte/" +
                  this.props.match.params.placeid +
                  "/results"
                }
              >
                <button
                  disabled=""
                  className="btn btn-default btn-primary right-button"
                >
                  WEITER ZUM ENDERGEBNIS
                </button>
              </Link>
            </div>
          ) : (
            <div>
              <Link to={"/wohnstandorte/vergleich"}>
                <button
                  disabled=""
                  className="btn btn-default btn-primary right-button"
                >
                  WEITER ZUM VERGLEICH
                </button>
              </Link>
            </div>
          )}

          <div className="help-block smalltext">
            <p />
            Sämtliche Daten und Informationen wurden sorgfältig ermittelt. Es
            kann jedoch keine Garantie für die Richtigkeit, Vollständigkeit und
            Aktualität der Angaben übernommen werden. Datenquellen: Land
            Oberösterreich, GIP, VAO, basemap.at, iSPACE
          </div>
        </div>
      </div>
    );
  }
}

class DailyTripsList extends React.Component {
  constructor(props) {
    super(props);

    this.howManyRoutesAreLoading = 0;

    this.state = {
      loadingRoute: false,

      dailyTrips: window.datastore.lps.get(this.props.placeid).get("dailyTrips")
    };

    this.showDailyTrips = this.showDailyTrips.bind(this);

    this.updateDailyTrips = this.updateDailyTrips.bind(this);

    this.handleLoadingCount = this.handleLoadingCount.bind(this);
  }

  showDailyTrips() {
    var dailyTrips = [];

    var dts = this.state.dailyTrips;

    for (var i = 0; i < dts.length; i++) {
      var dt = dts.models[i];

      dailyTrips.push(
        <DailyTrip
          key={dt.id}
          placeid={this.props.placeid}
          id={dt.id}
          changeCarsUsed={this.props.changeCarsUsed}
          changePubTransUsed={this.props.changePubTransUsed}
          refreshCosts={this.props.refreshCosts}
          updateDailyTrips={this.updateDailyTrips}
          loading={this.handleLoadingCount}
        />
      );
    }

    return dailyTrips;
  }

  handleLoadingCount(addOrRemove) {
    if (addOrRemove === "add") {
      this.howManyRoutesAreLoading = this.howManyRoutesAreLoading + 1;
    } else if (addOrRemove === "remove") {
      this.howManyRoutesAreLoading = this.howManyRoutesAreLoading - 1;
    }

    if (this.howManyRoutesAreLoading === 0) {
      this.props.loadingStatus(false);
    } else {
      this.props.loadingStatus(true);
    }
  }

  updateDailyTrips() {
    this.setState({
      dailyTrips: window.datastore.lps.get(this.props.placeid).get("dailyTrips")
    });
  }

  render() {
    return <div className="container-fluid">{this.showDailyTrips()}</div>;
  }
}

class DailyTrip extends React.Component {
  constructor(props) {
    super(props);

    this.lpobj = window.datastore.lps.get(this.props.placeid);

    this.dailyTargetObj = this.lpobj.get("dailyTrips").get(this.props.id);

    this.xhr = null;

    if (this.dailyTargetObj.get("enhancedByWebService")) {
      this.state = { hasLoaded: true };
    } else {
      this.state = { hasLoaded: false };
    }

    this.state.id_car = this.dailyTargetObj.get("id_car");

    this.state.freq = this.dailyTargetObj.get("freq");

    this.state.targetname = this.dailyTargetObj.get("name");

    this.state.purposetext = this.dailyTargetObj.get("purposetext");

    this.handleModeChange = this.handleModeChange.bind(this);

    this.changeCarForTrip = this.changeCarForTrip.bind(this);

    this.changeFreq = this.changeFreq.bind(this);

    this.checkFreqOnBlur = this.checkFreqOnBlur.bind(this);

    this.deleteTrip = this.deleteTrip.bind(this);

    this.changePurpose = this.changePurpose.bind(this);
  }

  componentDidMount() {
    var comp = this;

    function setResState() {
      var modes = comp.dailyTargetObj.get("transportModes");

      var car_time;

      var car_distance;

      var bike_time;

      var bike_distance;

      var walk_time;

      var walk_distance;

      var pt_time;

      var pt_costs;

      if (modes.CAR === null) {
        car_time = null;

        car_distance = null;
      } else {
        car_time = comp.dailyTargetObj.get("transportModes").CAR.duration;

        car_distance = comp.dailyTargetObj.get("transportModes").CAR.distance;
      }

      if (modes.BIKE === null) {
        bike_time = null;

        bike_distance = null;
      } else {
        bike_time = comp.dailyTargetObj.get("transportModes").BIKE.duration;

        bike_distance = comp.dailyTargetObj.get("transportModes").BIKE.distance;
      }

      if (modes.FOOT === null) {
        walk_time = null;

        walk_distance = null;
      } else {
        walk_time = comp.dailyTargetObj.get("transportModes").FOOT.duration;

        walk_distance = comp.dailyTargetObj.get("transportModes").FOOT.distance;
      }

      if (modes.PUBLIC === null) {
        pt_time = null;

        pt_costs = null;
      } else {
        if (
          comp.dailyTargetObj.get("transportModes").PUBLIC.monthlyPrice !== null
        ) {
          if (!comp.dailyTargetObj.get("enhancedByWebService")) {
            comp.dailyTargetObj.set({
              costs_pt: comp.dailyTargetObj.get("transportModes").PUBLIC
                .monthlyPrice
            });

            comp.dailyTargetObj.set({ auto_costs_pt: true });

            pt_costs = comp.dailyTargetObj.get("costs_pt");
          }
        } else {
          //					comp.dailyTargetObj.set({'costs_pt': 0});

          comp.dailyTargetObj.set({ auto_costs_pt: false });
        }

        pt_time = comp.dailyTargetObj.get("transportModes").PUBLIC.duration;
      }

      comp.dailyTargetObj.set({ enhancedByWebService: true });

      //comp.props.changePubTransUsed();

      var actCar = comp.lpobj
        .get("userCars")
        .get(comp.dailyTargetObj.get("id_car"));

      comp.setState({
        hasLoaded: true,

        selectedMode: comp.dailyTargetObj.get("selectedMode"),

        targetname: comp.dailyTargetObj.get("name"),

        purposetext: comp.dailyTargetObj.get("purposetext"),

        freq: comp.dailyTargetObj.get("freq"),

        car_time: car_time,

        car_distance: car_distance,

        bike_time: bike_time,

        bike_distance: bike_distance,

        walk_time: walk_time,

        walk_distance: walk_distance,

        pt_time: pt_time,

        pt_costs: pt_costs
      });
    }

    if (this.state.hasLoaded === false) {
      this.xhr = $.ajax({
        url: "dailytrip",

        data: {
          x1: comp.lpobj.get("xy")[0],

          y1: comp.lpobj.get("xy")[1],

          x2: comp.dailyTargetObj.get("xy")[0],

          y2: comp.dailyTargetObj.get("xy")[1]
        },

        type: "GET",

        beforeSend: function() {
          //$("body").css("cursor", "progress");

          comp.props.loading("add");
        },

        success: function(response) {
          //alert(response)

          comp.dailyTargetObj.set({ transportModes: response });

          setResState();
        },

        error: function() {
          comp.setState({
            hasLoaded: true
          });
        },

        complete: function(xhr) {
          comp.props.loading("remove");

          //$("body").css("cursor", "default");
        }
      });
    } else {
      setResState();
    }
  }

  componentWillUnmount() {
    if (this.xhr) {
      this.xhr.abort();
    }
  }

  handleModeChange(event) {
    this.setState({ selectedMode: event.target.value });

    this.dailyTargetObj.set({ selectedMode: event.target.value });

    this.props.changeCarsUsed();

    this.props.changePubTransUsed();

    this.props.refreshCosts();
  }

  changeCarForTrip(event) {
    this.setState({ id_car: event.target.value });

    this.dailyTargetObj.set({ id_car: event.target.value });

    this.props.changeCarsUsed();

    this.props.refreshCosts();
  }

  deleteTrip(event) {
    this.lpobj.get("dailyTrips").remove(this.dailyTargetObj);

    this.props.updateDailyTrips();

    this.props.changeCarsUsed();

    this.props.changePubTransUsed();

    this.props.refreshCosts();
  }

  changeFreq(event) {
    var freq = event.target.value;

    if (freq !== "" && !isNaN(parseInt(freq))) {
      freq = parseInt(freq);

      if (freq < 1) {
        freq = 1;
      }

      if (freq > 7) {
        freq = 7;
      }
    } else if (typeof freq === "string" && freq !== "") {
      freq = 5;
    }

    this.setState({ freq: freq });

    this.dailyTargetObj.set({ freq: freq });
   
    this.props.refreshCosts();
  }

  checkFreqOnBlur(event) {
    var freq = event.target.value;

    if (typeof freq === "string" && isNaN(parseInt(freq))) {
      this.setState({ freq: 5 });

      this.dailyTargetObj.set({ freq: 5 });
    }
  }

  changePurpose(event) {
    var txt = event.target.value;

    if (txt.length > 30) {
      txt = txt.slice(0, 29);
    }

    this.dailyTargetObj.set({ purposetext: txt });

    this.setState({ purposetext: txt });
  }

  //	changeFuelCosts(car, dt) {

  //		var costsPerMonth;

  //

  //		costsPerMonth = car.get('consumption_costs_per_m') * dt.get('freq') * 2 * dt.get('transportModes').CAR.distance * 4

  //		return costsPerMonth;

  //	}

  render() {
    function carOptions(cars) {
      var carOptions = [];

      for (var i = 0; i < cars.length; i++) {
        var car = cars.models[i];

        carOptions.push(
          <option value={car.id} key={car.id}>
            {"KFZ " + car.id}
          </option>
        );
      }

      return carOptions;
    }

    function showPtOption(comp) {
      if (comp.state.pt_time !== null) {
        return (
          <div>
            <div>
              <input
                type="radio"
                name={"options-mode-" + comp.props.id}
                checked={comp.state.selectedMode === "public"}
                value="public"
                onChange={comp.handleModeChange}
              />
              <strong> mit dem Öff. Verkehr</strong>
              <img
                className="transport-mode-symbol text-right"
                src={icon_pt}
              />
            </div>

            <div>
              <span>Zeit zum Ziel: {comp.state.pt_time} Min.</span>
            </div>

            {/*<div><span>Monatskosten: {comp.state.pt_costs} €</span></div>*/}
          </div>
        );
      } else {
        return <div>Keine ÖV-Verbindung gefunden</div>;
      }
    }

    function showTripData(comp) {
      if (comp.state.hasLoaded === false) {
        return <div>Lade Daten...</div>;
      } else if (comp.state.hasLoaded) {
        return (
          <div className="row daily-trip">
            <div className="row">
              <div className="col-xs-5 target-addr-text">
                <span className="bold">Weg nach: </span>

                <span>{comp.state.targetname}</span>
              </div>

              <div className="col-xs-4">
                <form className="form-inline purpose-input">
                  <div className="form-group">
                    <label htmlFor="purpose">Zweck:&nbsp;</label>

                    <input
                      type="text"
                      id="purpose"
                      className="form-control"
                      placeholder="Ausbildung, Arbeit..."
                      value={comp.state.purposetext}
                      onChange={comp.changePurpose}
                    />
                  </div>
                </form>
              </div>
            </div>

            <hr className="hr-daily-trip" />

            <div className="col-sm-1 transp-mode-res">{showPtOption(comp)}</div>

            <div className="col-sm-1 transp-mode-res">
              <div>
                <input
                  type="radio"
                  name={"options-mode-" + comp.props.id}
                  checked={comp.state.selectedMode === "car"}
                  value="car"
                  onChange={comp.handleModeChange}
                />
                <strong> mit KFZ</strong>

                <img
                  className="transport-mode-symbol text-right"
                  src={icon_car}
                />
              </div>

              <div>
                <span>Zeit zum Ziel: {comp.state.car_time} Min.</span>
              </div>

              {/*<div><span>Treibstoffk. pro Monat: {comp.state.fuelcosts} €</span></div>*/}

              <select
                className="form-control"
                value={comp.state.id_car}
                onChange={comp.changeCarForTrip}
              >
                {carOptions(comp.lpobj.get("userCars"))}
              </select>
            </div>

            <div className="col-sm-1 transp-mode-res">
              <div>
                <input
                  type="radio"
                  name={"options-mode-" + comp.props.id}
                  checked={comp.state.selectedMode === "bike"}
                  value="bike"
                  onChange={comp.handleModeChange}
                />
                <strong> mit dem Rad</strong>
                <img
                  className="transport-mode-symbol text-right"
                  src={icon_bike}
                />
              </div>

              <div>
                <span>Zeit zum Ziel: {comp.state.bike_time} Min.</span>
              </div>
            </div>

            <div className="col-sm-1 transp-mode-res">
              <div>
                <input
                  type="radio"
                  name={"options-mode-" + comp.props.id}
                  checked={comp.state.selectedMode === "foot"}
                  value="foot"
                  onChange={comp.handleModeChange}
                />
                <strong> zu Fuß</strong>
                <img
                  className="transport-mode-symbol text-right"
                  src={icon_walk}
                />
              </div>

              <div>
                <span>Zeit zum Ziel: {comp.state.walk_time} Min.</span>
              </div>
            </div>

            <div className="col-sm-1 frq-input">
              <div>
                <strong>Wie oft pro Woche?</strong>

                <input
                  type="number"
                  value={comp.state.freq}
                  onChange={comp.changeFreq}
                  onBlur={comp.checkFreqOnBlur}
                  className="form-control"
                  placeholder=""
                  min="1"
                  max="7"
                />

                <button
                  className="btn btn-default delete-trip"
                  onClick={comp.deleteTrip}
                >
                  <span
                    className="glyphicon glyphicon-remove-sign"
                    aria-hidden="true"
                  />{" "}
                  Weg löschen
                </button>
              </div>
            </div>
          </div>
        );
      }
    }

    return <div>{showTripData(this)}</div>;
  }
}

class AddDailyTripButton extends React.Component {
  constructor(props) {
    super(props);

    //		this.dailyTrips = window.datastore.lps.get(this.props.placeid).get('dailyTrips')

    //		this.getIdForNewDailyTrip = this.getIdForNewDailyTrip.bind(this);
  }

  //	getIdForNewDailyTrip() {

  //		var numberOfTrips = this.dailyTrips.length

  //		return (numberOfTrips + 1).toString()

  //	}

  render() {
    return (
      <Link to={"/wohnstandorte/" + this.props.id + "/waysmap"}>
        <button className="btn btn-success">
          <span className="glyphicon glyphicon-plus" aria-hidden="true" /> Neuen
          Weg hinzufügen
        </button>
      </Link>
    );
  }
}

class Settings extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    function showMultipleCarSettings(props) {
      var carSettings = [];

      for (var i = 0; i < props.carsUsed.length; i++) {
        carSettings.push(
          <CarSetting
            placeid={props.placeid}
            userCarId={props.carsUsed[i]}
            key={props.carsUsed[i]}
            refreshCosts={props.refreshCosts}
          />
        );
      }

      return carSettings;
    }

    function showMultiplePtSettings(props) {
      var ptSettings = [];

      for (var i = 0; i < props.tripIdsWithPt.length; i++) {
        ptSettings.push(
          <PtSetting
            placeid={props.placeid}
            tripId={props.tripIdsWithPt[i]}
            key={props.tripIdsWithPt[i]}
            refreshCosts={props.refreshCosts}
          />
        );
      }

      return ptSettings;
    }

    return (
      <div
        className={
          "daily-trips-settings" +
          (this.props.carsUsed.length === 0 &&
          this.props.tripIdsWithPt.length === 0
            ? " hidden"
            : "")
        }
      >
        <div className={this.props.carsUsed.length === 0 ? "hidden" : ""}>
          <h4>Kosten für Kraftfahrzeuge</h4>

          {showMultipleCarSettings(this.props)}
        </div>

        <div className={this.props.tripIdsWithPt.length === 0 ? "hidden" : ""}>
          <h4>Kosten für Bus & Bahn</h4>

          {showMultiplePtSettings(this.props)}
        </div>
      </div>
    );
  }
}

class CarSetting extends React.Component {
  constructor(props) {
    super(props);

    this.lpobj = window.datastore.lps.get(this.props.placeid);

    this.actCar = this.lpobj.get("userCars").get(this.props.userCarId);

    this.state = {
      chosenCarType: this.actCar.get("type"),

      monthlyCosts: this.actCar.get("costs_month")
    };

    this.changeCarType = this.changeCarType.bind(this);

    this.changeCarCosts = this.changeCarCosts.bind(this);
  }

  changeCarType(event) {
    var type = event.target.value;

    var defCar = this.lpobj.get("defaultCars").where({ type: type })[0];

    this.actCar.set("type", type),
      this.actCar.set("costs_month", defCar.get("costs_month"));

    this.setState({
      chosenCarType: type,

      monthlyCosts: defCar.get("costs_month")
    });

    this.props.refreshCosts();
  }

  changeCarCosts(event) {
    var costs = parseFloat(event.target.value);

    this.actCar.set("costs_month", costs);

    this.setState({
      monthlyCosts: costs
    });

    this.props.refreshCosts();
  }

  render() {
    return (
      <div>
        <h5 className="bold">{"KFZ " + this.props.userCarId}</h5>

        <div className="row">
          <div className="col-md-4">
            <p>Typ</p>

            <select
              className="form-control"
              value={this.state.chosenCarType}
              onChange={this.changeCarType}
            >
              <option value={"low"}>Kleinwagen</option>

              <option value={"medium"}>Mittelklasse</option>

              <option value={"high"}>Oberklasse</option>

              <option value={"motorcycle"}>Motorrad</option>
            </select>
          </div>

          <div className="col-md-4">
            <p>Kosten pro Monat OHNE Kraftstoff</p>

            <div className="input-group">
              <div className="input-group-addon">€</div>

              <input
                type="number"
                className="form-control"
                placeholder="€"
                value={this.state.monthlyCosts}
                onChange={this.changeCarCosts}
              />
            </div>
          </div>

          <div className="col-md-4" />
        </div>

        <p className="help-block">
          Die Kosten ergeben sich aus der Summe von Wertverlust, Versicherung
          und Wartung bei einer Nutzungsdauer von 6 Jahren. Diese Werte können
          beispielsweise mit dem{" "}
          <a href="http://www.oeamtc.at/ai-webapp/" target="_blank">
            ÖAMTC-Auto-Info Service
          </a>{" "}
          detailliert ermittelt werden.
        </p>
      </div>
    );
  }
}

class PtSetting extends React.Component {
  constructor(props) {
    super(props);

    this.lpobj = window.datastore.lps.get(this.props.placeid);

    this.dailyTargetObj = this.lpobj.get("dailyTrips").get(this.props.tripId);

    this.state = {
      monthlyCosts: this.dailyTargetObj.get("costs_pt"),

      name: this.dailyTargetObj.get("name"),

      autoFilled: this.dailyTargetObj.get("auto_costs_pt"),

      changed: false
    };

    this.changePtCosts = this.changePtCosts.bind(this);
  }

  changePtCosts(event) {
    var costs = parseFloat(event.target.value);

    this.dailyTargetObj.set("costs_pt", costs);

    this.setState({
      monthlyCosts: costs
    });

    this.props.refreshCosts();
  }

  render() {
    var helptext;

    if (this.state.autoFilled) {
      helptext =
        "Die Monatskosten wurden anhand des Preises für ein " +
        "Monatsticket für diese Strecke automatisch vorbefüllt.";
    } else {
      helptext =
        "Monatskosten konnten nicht automatisch ermittelt " +
        "werden. Bitte Kosten für diese Strecke selbst eingeben";
    }

    return (
      <div>
        <div className="row">
          <div className="col-md-2">
            <div>Nach: </div>

            <div className="short-name">{this.state.name}</div>
          </div>

          <div className="col-md-2">
            <div>Kosten pro Monat</div>

            <div
              className={
                "input-group " +
                (!this.state.autoFilled && !this.state.changed
                  ? "has-error"
                  : "has-success")
              }
            >
              <div className="input-group-addon">€</div>

              <input
                type="number"
                className="form-control"
                placeholder="€"
                value={this.state.monthlyCosts}
                onChange={this.changePtCosts}
              />

              {/*<div className="input-group-addon">

									<div className={"help glyphicon glyphicon-exclamation-sign " + (this.state.autoFilled ? "text-success" : "text-warning")} aria-hidden="true"></div>

								</div>*/}
            </div>
          </div>

          <div className="col-md-3">
            <div className="help-block smalltext">{helptext}</div>
          </div>
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/react_components/livingplaceprocess/dailytrips/daily_trips_page.js